import { render, staticRenderFns } from "./StudentAccount.vue?vue&type=template&id=7c8dd8be&"
import script from "./StudentAccount.vue?vue&type=script&lang=js&"
export * from "./StudentAccount.vue?vue&type=script&lang=js&"
import style0 from "./StudentAccount.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports